
import { mapActions, mapGetters } from 'vuex'
import BundleTitle from '../bundle-common/bundle-title.vue'
import ReturnsShipping from './returns-shipping.vue'
import LoleBtn from '@/components/buttons/lole-btn'
import Price from '~/components/price/price'
export default {
  components: {
    BundleTitle,
    ReturnsShipping,
    LoleBtn,
    Price,
  },
  inject: ['bundle', 'wording', 'wordingPageProduct'],
  props: {
    selectedProducts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      bundle: this.bundle,
      wording: this.wording,
      loadingAddToCart: false,
      stickyBottomBar: true,
    }
  },
  computed: {
    ...mapGetters({
      vxScroll: 'getScroll',
      vxCurrency: 'currency/getCurrency',
    }),
    stickyOffsetHeight() {
      return 120
    },
    productsCount() {
      return this.selectedProducts.length
    },
    strikeoutPrice() {
      return this.selectedProducts.reduce((acc, { product }) => {
        const strikeoutPrice = parseFloat(product?.strikeout_price) || 0
        const sum = strikeoutPrice + parseFloat(acc)
        acc = sum % 1 !== 0 ? sum.toFixed(2) : sum
        return acc
      }, 0)
    },
    bundlePrice() {
      return this.selectedProducts.reduce((acc, { product }) => {
        const sum = parseFloat(product.price) + parseFloat(acc)
        acc = sum % 1 !== 0 ? sum.toFixed(2) : sum
        return acc
      }, 0)
    },
  },
  watch: {
    'vxScroll.current'() {
      const mainCtaOffsetTop =
        this.$refs.mainBundleBuybox.getBoundingClientRect()

      if (mainCtaOffsetTop.top < window.innerHeight) {
        this.stickyBottomBar = false
        document.querySelector('.lole-site-container').removeAttribute('style')
      } else {
        this.stickyBottomBar = true
        document
          .querySelector('.lole-site-container')
          .setAttribute('style', `padding-bottom: ${this.stickyOffsetHeight}px`)
      }
    },
  },
  methods: {
    ...mapActions({
      vxAddProductsToCart: 'product/addProductsToCart',
    }),
    addToCart() {
      this.loadingAddToCart = true
      const productsToAdded = []
      this.selectedProducts.forEach(({ product, size }) => {
        productsToAdded.push({
          product,
          variant: {
            quantity: 1,
            size_name: size.name,
            id: size.id,
          },
        })
      })
      this.vxAddProductsToCart({
        location: 'bundle-kit',
        products: productsToAdded,
      }).then(() => {
        this.loadingAddToCart = false
        this.reset = true
      })
    },
  },
}
